export default "__VITE_ASSET__Ck8pYb6K__"